import React, { Component } from 'react'

export default class DashboardButton extends Component {
    render() {
        const {icon ,title, onClick} = this.props
        
        return (
            <button onClick={onClick} className='z-0 group flex items-center justify-center w-full lg:w-80 p-6 lg:p-0 lg:h-44 flex-row gap-3 rounded-xl border-[3px] border-[#FCD49F] bg-[#EEEEEE] hover:bg-[#F89A1F] transition-all'>
                <img className='w-5 lg:w-6 group-hover:hidden transition-all' src={icon} alt="Tag" />
                <span className='font-semibold text-base lg:text-xl group-hover:text-white'>{title}</span>
            </button>
        )
    }
}
